import { useState, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { select_os_all_versions, select_userAgentsOSList } from 'store/selectors';
import { useToggleState } from './useToggleState';
import { generalActions, targetingPlacementsActions } from 'store/actions';

export const useFacade = () => {
  const dispatch = useDispatch();

  const [search, setSearch] = useState('');
  let all_versions = useSelector(select_os_all_versions);

  const selected_os_versions_numbers = useSelector(select_userAgentsOSList);

  const { state, isActive, toggle, toggleAllOff, saveBtnFlag } = useToggleState(
    selected_os_versions_numbers,
  );

  const handleSearchOnChange = useCallback((e) => {
    setSearch(e.target.value || '');
  }, []);

  const faundedVersions = useMemo(() => {
    if (!search) return all_versions;
    return all_versions.filter((version) => version.label.includes(search));
  }, [search]);

  const handleClearSearchValue = useCallback(() => {
    setSearch('');
  }, []);

  const saveButtonClick = useCallback(() => {
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'userAgentsOSList',
        newValue: state.join(','),
      }),
    );
    dispatch(
      targetingPlacementsActions.updateErrorField({
        errorField: 'os',
        newValue: false,
      }),
    );
    dispatch(generalActions.setMinBidAsNotRelevant());
  }, [state]);

  return {
    search,
    handleSearchOnChange,
    handleClearSearchValue,
    faundedVersions,
    isActive,
    toggle,
    state,
    toggleAllOff,
    saveButtonClick,
    saveBtnFlag,
  };
};
